import { memo } from "react";
import { jsx } from "react/jsx-runtime";
//#region src/icons/icon-24-camera.tsx
/**
* icon.24.camera
*
* Keywords: video, camera, recording, media, capture, film, play, streaming
*
* ![](data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSI2NCIgaGVpZ2h0PSI2NCIgZmlsbD0ibm9uZSIgdmlld0JveD0iMCAwIDI0IDI0Ij48cmVjdCB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIGZpbGw9IiMwMDAiIHJ4PSI0Ii8+PHBhdGggZmlsbD0iI2ZmZiIgZmlsbC1ydWxlPSJldmVub2RkIiBkPSJNNy41IDhoNkExLjUgMS41IDAgMCAxIDE1IDkuNXY1YTEuNSAxLjUgMCAwIDEtMS41IDEuNWgtNkExLjUgMS41IDAgMCAxIDYgMTQuNXYtNUExLjUgMS41IDAgMCAxIDcuNSA4bTguNSA1LjkxNHYuNTg2YTIuNSAyLjUgMCAwIDEtMi41IDIuNWgtNkEyLjUgMi41IDAgMCAxIDUgMTQuNXYtNUEyLjUgMi41IDAgMCAxIDcuNSA3aDZBMi41IDIuNSAwIDAgMSAxNiA5LjV2LjU4NmwxLjI5My0xLjI5M0ExIDEgMCAwIDEgMTkgOS41djVhMSAxIDAgMCAxLTEuNzA3LjcwN3ptMC0xLjQxNCAxIDEgMSAxdi01bC0xIDEtMSAxeiIgY2xpcC1ydWxlPSJldmVub2RkIi8+PC9zdmc+)
*
* https://staging.figma.com/file/ycDPAaAih2bZY5LgXehVai/?node-id=1-4459
*/
const Icon24Camera = memo(function Icon24Camera(props) {
	return /* @__PURE__ */ jsx("svg", {
		width: "24",
		height: "24",
		fill: "none",
		viewBox: "0 0 24 24",
		...props,
		"data-fpl-icon-size": "24",
		children: /* @__PURE__ */ jsx("path", {
			fill: "var(--fpl-icon-color, var(--color-icon))",
			fillRule: "evenodd",
			d: "M7.5 8h6A1.5 1.5 0 0 1 15 9.5v5a1.5 1.5 0 0 1-1.5 1.5h-6A1.5 1.5 0 0 1 6 14.5v-5A1.5 1.5 0 0 1 7.5 8m8.5 5.914v.586a2.5 2.5 0 0 1-2.5 2.5h-6A2.5 2.5 0 0 1 5 14.5v-5A2.5 2.5 0 0 1 7.5 7h6A2.5 2.5 0 0 1 16 9.5v.586l1.293-1.293A1 1 0 0 1 19 9.5v5a1 1 0 0 1-1.707.707zm0-1.414 1 1 1 1v-5l-1 1-1 1z",
			clipRule: "evenodd"
		})
	});
});
//#endregion
export { Icon24Camera };

//# sourceMappingURL=icon-24-camera.js.map